module.exports = [{"type":"twitter","url":"https://twitter.com/olishiz","label":"@olishiz"},{"type":"pencil","url":"mailto:zhuen1101@hotmail.com","label":"zhuen1101@hotmail.com"},{"type":"github","url":"https://github.com/olishiz","label":"olishiz"},{"type":"linkedin","url":"https://www.linkedin.com/in/olishiz/","label":"in/olishiz"},{"type":"pdf","url":"https://drive.google.com/file/d/1IobIxRebHWA48C_7ekFvrZGwSpPFaVaA/view?usp=sharing","label":"pdf/resume"},{"type":"terminal","url":"https://olishiz.github.io/portfolio/","label":"Display VS Code Portfolio: olishiz.github.io/portfolio"}]


//////////////////
// WEBPACK FOOTER
// ./app/assets/js/database/social.json
// module id = fP2B
// module chunks = 2